import { render, staticRenderFns } from "./GotoRegistration.vue?vue&type=template&id=5f7b8ad2"
import script from "./GotoRegistration.vue?vue&type=script&lang=js"
export * from "./GotoRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports